import { animate, state, style, transition, trigger } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { LaravelResourceResponse } from '../../../../../../../_base-shared/contracts/laravel-response.interface';
import { Case } from '../../../../../../../_base-shared/models/Case/Case';
import { CaseCreditorPivot } from '../../../../../../../_base-shared/models/Case/CaseCreditor';
import { PaymentMethod, PaymentMethodType } from '../../../../../../../_base-shared/models/Payment/PaymentMethod';
import { PaymentProcessorType } from '../../../../../../../_base-shared/models/Payment/PaymentProcessor';
import { PaymentTerm } from '../../../../../../../_base-shared/models/Payment/PaymentTerm';
import { PaymentPlanType } from '../../../../../../../_base-shared/models/Product/PaymentPlanType';
import { User } from '../../../../../../../_base-shared/models/User/User';
import { environment } from '../../../../../environments/environment';
import {
  ChangeAmountModalComponent,
} from '../../../../_shared/components/change-amount-modal/change-amount-modal.component';
import {
  ChangeDateModalComponent,
} from '../../../../_shared/components/change-date-modal/change-date-modal.component';
import {
  RequestPaymentModalComponent,
} from '../../../../_shared/components/request-payment-modal/request-payment-modal.component';
import { MainGlobalEventService } from '../../../../_shared/services/main-global-event.service';
import { DistributionService } from '../../../../distribution/distribution.service';
import {
  AdminPaymentHandlerComponent
} from '../../../payment/admin-payment-handler/admin-payment-handler.component';
import { PaymentMethodService } from '../../../payment/payment-method.service';
import { PaymentPlanTypeService } from '../../../payment/payment-plan-type.service';
import { PaymentService } from '../../../payment/payment.service';
import { CaseDocumentService } from '../../case-document.service';
import { saveAs } from 'file-saver';
import { CaseService } from '../../../case/case.service';

@Component({
  standalone: false,
  selector: 'app-case-client-activity',
  templateUrl: './case-client-activity.component.html',
  styleUrls: ['./case-client-activity.component.scss']
})
export class CaseClientActivityComponent {
  public componentType: 'admin' = 'admin';
  public case: Case;
  @Input() fetchInstalments: EventEmitter<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public appEnv: string;
  public upcomingInstallments: Array<PaymentTerm> = [];
  public unpaidInstallments                       = [];
  public displayedColumns: Array<string>          = [];
  public installmentsPlanTypeControl              = new UntypedFormControl(['debt_plan'], [Validators.required]);
  public dataSource: MatTableDataSource<PaymentTerm>;
  public dataSourceUnpaid: MatTableDataSource<PaymentTerm>;
  public recordForm: UntypedFormGroup;
  public totalResults: number;
  public showOnlyUnpaid                           = false;
  public sortOrder                                = null;
  public sortBy                                   = null;
  public filteredInstallmentsBalance              = {
    totalPaid:  0,
    totalToPay: 0,
    totalPaidCounter: 0,
    totalDistributed: 0,
  };
  public debtPlanInstallmentsBalance              = {
    totalPaid:  0,
    totalToPay: 0,
  };
  public additionalPlansInstallmentsBalance       = {
    totalPaid:  0,
    totalToPay: 0,
  };
  public paginatorConfig                          = {
    pageIndex: 0,
    pageSize:  10,
    length:    1,
  };
  public now                                      = new Date(new Date().setHours(0, 0, 0, 0));
  public days                                     = [];
  public isLoading                                = 0;
  public authUser: User;
  public paymentMethods: Array<PaymentMethod>;
  public paymentPlanTypes: Array<PaymentPlanType>;
  private forceDefaultProcessor                   = false;
  public selectionPayments                        = new SelectionModel<any>(true, []);
  public selectionPaymentsDisabled                = true;
  public onlyDebtPlanSelected                     = true;
  public isSubmitting: boolean;

  public expandedRow: number;
  public expandedElement: CaseCreditorPivot | null;
  public templateData: Array<any> = [];
  public creditorsMerged: Array<any> = [];

  public authorizedUsers                          = [27, 751562, 751600, 752733];
  //public excludedStatuses: number[] = [11,14,15,19,24,25,26,27,33,36];
  public excludedProductId: number[] = [18];
  public serverResponse: LaravelResourceResponse;
  public runningBalance: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private translate: TranslateService,
    private globalEventsService: MainGlobalEventService,
    private paymentService: PaymentService,
    private distributionService: DistributionService,
    private paymentMethodService: PaymentMethodService,
    private paymentPlanTypeService: PaymentPlanTypeService,
    private caseDocumentService: CaseDocumentService,
    private caseService: CaseService,
  ) {
    this.appEnv = environment.APP_ENV;
    this.case=null;
  }


  ngOnInit(): void {

    this.route.parent.paramMap.subscribe(params => {
      const caseId = +params.get('id');
      this.isLoading++;
      this.caseService.get(caseId, ['client', 'payment_plans', 'terms', 'creditors', 'public_debts', 'debt_payment_plan', 'secured_creditors', 'unsecured_creditors', 'expense'])
        .pipe(finalize(() => this.isLoading--))
        .subscribe(
          result => {
            this.case = result.data;
            console.log("case infoooo");
            console.log(this.case);
            this.displayedColumns = this.getTableColumns(this.componentType);
            this.fetchInstallments(this.componentType);

            //  Get total amount of paid terms and total amount to pay
            this.case.terms.forEach(term => {
              this.filteredInstallmentsBalance.totalToPay += term.amount;
              this.filteredInstallmentsBalance.totalPaid += term.amount_paid;
              this.filteredInstallmentsBalance.totalPaidCounter += this.filteredInstallmentsBalance.totalPaidCounter;
              if (term.case_plan_id === this.case.debt_payment_plan.id) {
                this.debtPlanInstallmentsBalance.totalToPay += term.amount;
                this.debtPlanInstallmentsBalance.totalPaid += term.amount_paid;
              }
              if (term.case_plan_id !== this.case.debt_payment_plan.id) {
                this.additionalPlansInstallmentsBalance.totalToPay += term.amount;
                this.additionalPlansInstallmentsBalance.totalPaid += term.amount_paid;
              }
            });

            /*this.selectionPayments.changed.subscribe(next => {
              this.checkIfDisabled(next);
            });*/

            //better to calculate if phase1 or 2 using variables than calling from the template
            //this.templateData.push(this.viewCalculations());
          },
          error => this.serverResponse = error.error,
        )
    });

    this.globalEventsService.authUser$.subscribe(user => {
      this.authUser         = user;
      //this.fetchPaymentPlanTypes(this.componentType);
    });

    //  Generate days array
    for (let i = 1; i <= 31; i++) {
      this.days.push(i);
    }

  }

  private fetchInstallments(componentType: 'admin') {
    const data = {
      per_page:        this.paginatorConfig.pageSize,
      page:            this.paginatorConfig.pageIndex + 1,
      case_id:         this.case.id,
      select_all:      1,
      order:           this.sortOrder || 'asc',
      sort_by:         this.sortBy || 'term_date',
      plan_type_slugs: this.installmentsPlanTypeControl.value ? this.installmentsPlanTypeControl.value : [],
    };

    const withRelations = [
      'case.client',
      'case.debt_payment_plan',
      'distribution_case_terms',
      //'case.terms',
      'distribution_case_terms.batches',
      'case.payment_status',
      'case_payment_plan.type',
      'case.distribution',
    ];

    const observable    = this.paymentService.indexCaseInstallments(this.case.id, data, withRelations)
    //const observable    = componentType === 'admin' ?
    //  this.paymentService.indexCaseInstallments(this.case.id, data, withRelations) :
    //  this.distributionService.indexInstallments(this.case.uuid, data, withRelations);

    this.isLoading++;
    this.dataSource           = new MatTableDataSource<PaymentTerm>([]);
    this.upcomingInstallments = [];
    observable.pipe(finalize(() => this.isLoading--))
      .subscribe(
        res => this.handleResponse(res),
        error => console.log(error),
      );
  }

  public saveTermId(installment: PaymentTerm) {
    const dialogRef = this.dialog.open(ChangeDateModalComponent, {
      width: '50%',
      data:  {
        term: installment,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fetchInstallments(this.componentType);
      }
    });
  }

  public toggleRow(element: any) {
    element.expanded = !element.expanded;
  }

  public showHideUnpaid($event) {
    this.paginator.firstPage();
    if ($event.checked) {
      this.paginatorConfig.length = this.unpaidInstallments.length;
    } else {
      this.paginatorConfig.length = this.upcomingInstallments.length;
    }
    this.showOnlyUnpaid = $event.checked;
  }

  public sortData(sort) {
    this.sortOrder = sort.direction !== '' ? sort.direction : null;
    this.sortBy    = sort.direction !== '' ? sort.active : null;

    this.fetchInstallments(this.componentType);
  }

  public openChangeAmountModal(installment: PaymentTerm) {
    const dialogRef = this.dialog.open(ChangeAmountModalComponent, {
      width: '50%',
      data:  {
        term: installment,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fetchInstallments(this.componentType);
      }
    });
  }

  public requestPaymentDialog(paymentMethodType: PaymentMethodType, paymentProcessorType: PaymentProcessorType): void {
    const nextTerm       = this.upcomingInstallments.find(t => t.amount > t.amount_paid);
    let maxPayableAmount = 0;
    this.upcomingInstallments.forEach(term => {
      maxPayableAmount += term.amount - term.amount_paid;
    });

    maxPayableAmount = +maxPayableAmount.toFixed(2);

    if (nextTerm) {
      const dialogRef = this.dialog.open(RequestPaymentModalComponent, {
        width:        '50%',
        minHeight:    200,
        disableClose: true,
        autoFocus:    false,
        data:         {
          caseId:                this.case.id,
          paymentMethodType,
          paymentProcessorType,
          amount:                (nextTerm.amount - nextTerm.amount_paid).toFixed(2),
          maxPayableAmount,
          forceDefaultProcessor: this.forceDefaultProcessor,
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result.success) {
            this.toastr.success(this.translate.instant(
              'CASES.single.request-payment-success'), this.translate.instant('SHARED.success'),
            );
          } else {
            this.toastr.error(this.translate.instant(
              'CASES.single.request-payment-error'), this.translate.instant('SHARED.error'),
            );
          }
        }
      });
    } else {
      this.toastr.error('No installment available');
    }
  }

  public openCardModal(): void {
    const nextTerm       = this.upcomingInstallments.find(t => t.amount > t.amount_paid);
    const chargeAmount   = nextTerm ? (nextTerm.amount - nextTerm.amount_paid).toFixed(2) : 0;
    let maxPayableAmount = 0;
    this.upcomingInstallments.forEach(term => {
      maxPayableAmount += term.amount - term.amount_paid;
    });

    if (nextTerm) {
      const dialogRef = this.dialog.open(AdminPaymentHandlerComponent, {
        width:        '60%',
        minHeight:    200,
        disableClose: false,
        panelClass:   ['custom-mat-dialog', 'scrollable-mat-dialog'],
        autoFocus:    false,
        data:         {
          caseId:          this.case.id,
          clientRole:      'client',
          type:            'moto',
          amount:          chargeAmount,
          editableAmount:  true,
          maxPayableAmount,
          paymentPlanType: this.forceDefaultProcessor ? 'additional_plans' : 'debt_plan',
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.reFetch) {
          this.fetchInstallments(this.componentType);
          this.fetchInstalments.emit();
          this.displayDistributionWarningModal();
        }
      });
    }
  }

  public buildForm() {
    const defaultPaymentMethod = this.paymentMethods.find(m => m.slug === 'sepa');
    const defaultIncomeAccount = defaultPaymentMethod.billing_bank_accounts.find(account => account.default === true);
    const defaultPlanId        = this.paymentPlanTypes.find(planType => planType.slug === 'debt_plan');

    this.recordForm = this.fb.group({
      case_id:           this.case.id,
      payment_plan_id:   defaultPlanId?.id ? defaultPlanId.id : null,
      note:              '',
      payment_date:      [new Date()],
      payment_method_id: [defaultPaymentMethod.id],
      payment_method:    [defaultPaymentMethod.slug],
      income_account_id: [defaultIncomeAccount.id, Validators.required],
      split_type:        ['custom', null],
      amount:            [0, Validators.required],
      amount_paid:       [null, Validators.required],
      phase_one_amount:  [0, null],
      phase_two_amount:  [0, null],
      phase_one_paid:    [
        this.upcomingInstallments.filter(
          term => (term.type === null || term.type === 'phase_one' || term.type === 'deferred_one') && term.amount >
            term.amount_paid).length === 0, null],
      phase_two_paid:    [
        this.upcomingInstallments.filter(
          term => (term.type === 'phase_two' || term.type === 'deferred_two') && term.amount >
            term.amount_paid).length === 0, null],
      terms:             this.fb.array([]),
      terms_phase_one:   this.fb.array(
        this.upcomingInstallments.filter(
          term => term.type === null || term.type === 'phase_one' || term.type === 'deferred_one'),
      ),
      terms_phase_two:   this.fb.array(this.upcomingInstallments.filter(term => term.type === 'phase_two')),
    });
    this.addInstalments();
    this.calculateAmountPaid();
  }

  addInstalments() {
    const instalments = this.recordForm.get('terms') as UntypedFormArray;
    this.upcomingInstallments.forEach(term => {
      instalments.push(
        this.fb.group({
          id:              term.id,
          term_date:       term.term_date,
          date_paid:       term.date_paid,
          type:            term.type,
          name:            term.name,
          amount:          term.amount,
          amount_paid:     0,
          old_amount_paid: term.amount_paid,
        }),
      );
    });
  }

  calculateAmountPaid() {
    let phaseOneAmount = 0;
    let phaseTwoAmount = 0;
    let amountPaid     = 0;
    let amountPayable  = 0;
    this.upcomingInstallments.forEach(term => {
      amountPayable += term.amount - term.amount_paid;
      amountPaid += term.amount_paid;
      if (term.type === null || term.type === 'phase_one' || term.type === 'deferred_one') {
        phaseOneAmount += term.amount - term.amount_paid;
      } else if (term.type === 'phase_two' || term.type === 'deferred_two') {
        phaseTwoAmount += term.amount - term.amount_paid;
      }
    });
    amountPayable = +amountPayable.toFixed(2);
    this.recordForm.get('phase_one_amount').setValue(phaseOneAmount);
    this.recordForm.get('phase_two_amount').setValue(phaseTwoAmount);
    this.recordForm.get('amount_paid').setValue(amountPaid);
    this.recordForm.get('amount').setValidators([Validators.required, Validators.max(Math.min(amountPayable, 4000))]);
  }

  public getDistributionSchedule(term, previousDistributionDate = null) {

    if (term.type === "phase_one") {
      return null;
    }

    const currentDate = new Date();
    const termDate = new Date(term.term_date);
    const datePaid = term.date_paid ? new Date(term.date_paid) : null;

    const currentNextMont = new Date();
    currentNextMont.setMonth(currentNextMont.getMonth() + 1);

    // Set distribution to the 15th of the month following termDate
    let distributionDate = new Date(termDate.getFullYear(), termDate.getMonth() + 1, 15);

    // If there's a previous distribution date (due to an unpaid installment), use it
    if (previousDistributionDate) {
      const previousDate = new Date(previousDistributionDate);

      // Only update if the previous distribution date is not in the same month
      if (previousDate.getMonth() !== termDate.getMonth()) {
        distributionDate = new Date(previousDate.getFullYear(), previousDate.getMonth() + 1, 15);

        // If no payment is made, return the calculated distribution date
        if (!datePaid) {
          return distributionDate;
        }

        // If a payment is made, adjust the distribution based on the payment date
        distributionDate = new Date(datePaid.getFullYear(), datePaid.getMonth() + 1, 15);
      }
    }

    // Handle the case where date_paid is between the 1st and 5th of the next month
    const nextMonth = new Date(distributionDate.getFullYear(), distributionDate.getMonth(), 1);
    const fifthOfNextMonth = new Date(distributionDate.getFullYear(), distributionDate.getMonth(), 7); //requested change to 7 temporarly

    // Payment after the 5th of the next month -> shift distribution date one month further
    if (datePaid && datePaid > fifthOfNextMonth) {
      distributionDate = new Date(distributionDate.getFullYear(), distributionDate.getMonth() + 1, 15);
      return distributionDate;
    }

    // Payment is made before or on the 5th of the next month -> keep the next month's 15th
    if (datePaid && datePaid >= nextMonth && datePaid <= fifthOfNextMonth) {
      return distributionDate;
    }

    // No payment made, return the distribution date based on the current date or previous date
    if (!datePaid) {
      distributionDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 15);
      if (previousDistributionDate){
        const previousDate = new Date(previousDistributionDate);
        if (previousDate.getTime() >= distributionDate.getTime()){
          distributionDate = new Date(previousDate.getFullYear(), previousDate.getMonth() +1, 15);
        }
      }
      return distributionDate;
    }

    //when previous is larger than current and payment is done between 1-5 next month
    if(datePaid && previousDistributionDate && previousDistributionDate > currentNextMont){
      //const previousDate = new Date(previousDistributionDate);
      const fifthOfNextMonth = new Date(datePaid.getFullYear(), datePaid.getMonth(), 7); //requested change to 7 temporarly

      if (datePaid <= fifthOfNextMonth) {
        distributionDate = new Date(datePaid.getFullYear(), datePaid.getMonth(), 15);
      }else{
        distributionDate = new Date(datePaid.getFullYear(), datePaid.getMonth() +1, 15);
      }
    }

    return distributionDate;
  }

  public handleResponse(response: LaravelResourceResponse) {
    //  Get total amount of paid terms and total amount to pay
    this.filteredInstallmentsBalance.totalToPay = 0;
    this.filteredInstallmentsBalance.totalPaid  = 0;
    this.filteredInstallmentsBalance.totalPaidCounter = 0;
    this.filteredInstallmentsBalance.totalDistributed = 0;

    let runningBalance = 0;
    const monthlyFee = 35;

    response.data.forEach(term => {
      term.notes = "";
      term.monthly_fees = 0;
      term.cred_settlement = 0;
      term.negotiation_fees = 0;
      term.balance_of_funds = 0;

      this.filteredInstallmentsBalance.totalToPay += term.amount;
      this.filteredInstallmentsBalance.totalPaid += term.amount_paid;
      this.filteredInstallmentsBalance.totalPaidCounter += this.filteredInstallmentsBalance.totalPaidCounter;

      if (!term?.type) {
        term.monthly_fees = "";
        term.balance_of_funds = "";
        term.negotiation_fees = term.amount;
        const paymentPlansArray = Array.isArray(this.case.payment_plans) ? this.case.payment_plans : [];
        const paymentPlan = paymentPlansArray.find(plan => plan.id === term.case_plan_id);
        if (paymentPlan?.creditor_id) {
          const creditor = this.case.creditors.find(cred => cred.pivot.id === paymentPlan.creditor_id);
          term.notes = creditor ? creditor.name : 'Unknown Creditor';
          term.cred_settlement = creditor.pivot.negotiated_amount;
        } else {
          term.notes = 'No Creditor Found';
        }
      } else {
        if (term.type == 'phase_one'){
          term.notes = 'Initial Fee';
          term.monthly_fees = term.amount;
        }
        if (term.type == 'phase_two'){
          term.monthly_fees = monthlyFee;
        }
      }

      runningBalance += term.amount - term.monthly_fees;
      if (!term?.type) {
        runningBalance -= term.cred_settlement;
        term.balance_of_funds = runningBalance;
      }else if (term.type == 'phase_two'){
        term.balance_of_funds = runningBalance;
      }

      /*term.distribution_case_terms.forEach(dist => {

        const isTermInDistribution = term.case.distribution.some((caseDist: any) =>
            caseDist.distribution_batch_id === dist.batches.id
        );

        if (!isTermInDistribution) {
            console.log(`Batch ID ${dist.batches.id} is not in term.case.distribution`);
            return;
        }

        this.filteredInstallmentsBalance.totalDistributed += dist.amount_distributed;
        totalTermDistribution += dist.amount_distributed;
        if (dist.disbursed){
          totalTermDisburse += dist.amount_distributed;
        }
        if (term.id === dist.term_id &&
            dist.distributed_at != null &&
            dist.distributed_at !== undefined
            && dist.distributed_at !== '') {
              term_distributed_at = dist.distributed_at;
        }
        if (term.id === dist.term_id &&
          dist.disbursed_at != null &&
          dist.disbursed_at !== undefined
          && dist.disbursed_at !== '') {
            term_disbursed_at = dist.disbursed_at;
        }
      });
      term.total_distributed_amount = totalTermDistribution;
      term.total_disbursed_amount = totalTermDisburse;*/
      //term.distribution_schedule = this.getDistributionSchedule(term, previousDistributionDate);
      //previousDistributionDate = term.distribution_schedule;
      //term.distributed_at = term_distributed_at;
      //term.disbursed_at = term_disbursed_at;
      //term.offer_to_creditors_total = Number(this.case.expense.offer_to_creditors_total);
      //term.distribution_fee = Number(this.case.expense.distribution_fee);

    });

    const onlyUnpaid = response.data.filter(obj => obj.amount !== obj.amount_paid);

    this.totalResults               = response.data.total;
    this.upcomingInstallments       = response.data;
    this.unpaidInstallments         = onlyUnpaid;
    this.dataSource                 = new MatTableDataSource<PaymentTerm>(response.data);
    this.dataSourceUnpaid           = new MatTableDataSource<PaymentTerm>(onlyUnpaid);
    this.dataSource.paginator       = this.paginator;
    this.dataSource.sort            = this.sort;
    this.dataSourceUnpaid.paginator = this.paginator;
    this.dataSourceUnpaid.sort      = this.sort;
    this.paginatorConfig.length     = response.data.length;
  }

  public getPercent(paid, amount) {
    if ((paid / amount) * 100) {
      return ((paid / amount) * 100).toFixed(2);
    } else {
      return 0;
    }
  }

  displayDistributionWarningModal(): void {
    Swal.fire({
      text:               this.translate.instant('DISTRIBUTION.modals.confirm-payment'),
      icon:               'warning',
      showCancelButton:   false,
      confirmButtonText:  'OK',
      confirmButtonColor: '#4267b2',
    });
  }

  public updateComponentType(type: 'admin') {
    this.componentType    = type;
    this.displayedColumns = this.getTableColumns(type);
    this.fetchInstallments(type);
  }

  private getTableColumns(type: 'distribution' | 'admin'): Array<string> {
    const columns = [
      //'select',
      //'client-name',
      //'email',
      //'name',
      'next-payment',
      'date-paid',
      'amount',
      'cred-settlement',
      'monthly-fees',
      'negotiation-fees',
      'balance-of-funds',
      'notes'
    ];
    //if (type === 'admin') {
    //  columns.push('actions');
    //}

    return columns;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(selection, dataSource) {
    const numSelected = selection.selected.length;
    const numRows     = dataSource.data.length;

    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(selection, dataSource) {
    if (this.isAllSelected(selection, dataSource)) {
      selection.clear();
      return;
    }

    selection.select(...dataSource.data);
  }

  public isElementRestricted(){

    const enabledRoles = environment.ALLOW_CASES_ROLES_IDS;
    const enabledStatusId = environment.BLOCK_CASES_STATUS_IDS;
    const enabledDepartmentsId = environment.ALLOW_CASES_DEPARTMENTS_IDS;

    const isDepartmentAllowed = this.authUser.departments.some(department =>
      enabledDepartmentsId.includes(department.id)
    );

    if (
      !enabledStatusId.includes(this.case.status_id) ||
       enabledRoles.includes(this.authUser.role_id) ||
       isDepartmentAllowed
    ){
      return true;
    }
    return false;
  }

}
